import fetchBHApi from "@helper/fetchBHApi";
import { BAASResponse, BAASV3Response } from "@typings/MyBH";
import { useCallback, useState } from "react";

/**
 *
 * @param visitorId Current user visitorId
 * @returns Baas response based on the user followed
 */

export default function useGetFollowedTopic(visitorId: string) {
  const [userInfoState, setUserInfoState] = useState<{
    topicResponse: BAASResponse[];
  }>({
    topicResponse: [],
  });

  const getFollowedTopic = useCallback(async () => {
    const fallback: BAASResponse[] = [];
    try {
      if (visitorId === "") fallback;

      const response = await fetchBHApi<BAASV3Response>(
        "baasGetFollowedDetails",
        "GET",
        {},
        {
          visitorID: visitorId,
        },
      );

      const tags =
        response.code === 200 && Array.isArray(response.tags)
          ? response.tags
          : fallback;

      setUserInfoState({ topicResponse: tags });

      return tags;
    } catch (error) {
      setUserInfoState({ topicResponse: fallback });
      return fallback;
    }
  }, [visitorId]);

  return {
    topicResponse: userInfoState.topicResponse,
    getFollowedTopic,
  };
}
